
import ToolsPasswordIcon from '../../../assets/ToolsPasswordIcon.png';
import ToolsUnlockIcon from '../../../assets/ToolsUnlockIcon.png';
import ToolsEncryptIcon from '../../../assets/ToolsEncryptIcon.png';
import ToolsDecryptIcon from '../../../assets/ToolsDecryptIcon.png';

import SplitIcon from '../../../assets/SplitIcon.png';
import ReorderIcon from '../../../assets/ReorderIcon.png';
import MergeIcon from '../../../assets/MergeIcon.png';
import RotateIcon from '../../../assets/RotateIcon.png';
import DeleteIcon from '../../../assets/DeleteIcon.png';

import ToolsFormsIcon from '../../../assets/ToolsFormsIcon.png';
import ToolsMcqIcon from '../../../assets/ToolsMcqIcon.png';
import ToolsResumeIcon from '../../../assets/ToolsResumeIcon.png';

import ToolsImagePdfIcon from '../../../assets/ToolsImagePdfIcon.png';
import ToolsTextIcon from '../../../assets/ToolsTextIcon.png';
import ToolsHighlightIcon from '../../../assets/ToolsHighlightIcon.png';
import ToolsWatermarkIcon from '../../../assets/ToolsWatermarkIcon.png';
import EsignYellowIcon from '../../../assets/EsignYellowIcon.png';
import EraseYellowIcon from '../../../assets/EraseYellowIcon.png';

import CompressIcon from '../../../assets/CompressIcon.png';
import ToolsWebpIcon from '../../../assets/ToolsWebpIcon.png';
import ToolsJpgIcon from '../../../assets/ToolsJpgIcon.png';
import ResizeIcon from '../../../assets/ResizeIcon.png';

import PdfToImage from '../../../assets/PdfToImage.png';
import PdfToLong from '../../../assets/PdfToLong.png';
import PdfToPpt from '../../../assets/PdfToPpt.png';
import PdfToWord from '../../../assets/PdfToWord.png';
import PdfToExcel from '../../../assets/PdfToExcel.png';
import ImageToPdf from '../../../assets/ImageToPdf.png';
import PptToPdf from '../../../assets/PptToPdf.png';
import ExcelToPdf from '../../../assets/ExcelToPdf.png';
import WordToPdf from '../../../assets/WordToPdf.png';
import WebpageToPdf from '../../../assets/WebpageToPdf.png';
import TextToPdf from '../../../assets/TextToPdf.png';

import HeadingEditIcon from '../../../assets/HeadingEditIcon.png';
import HeadingOrganizeIcon from '../../../assets/HeadingOrganizeIcon.png';
import HeadingCreateIcon from '../../../assets/HeadingCreateIcon.png';
import HeadingEditImageIcon from '../../../assets/HeadingEditImageIcon.png';
import HeadingConvertFromPdfIcon from '../../../assets/HeadingConvertFromPdfIcon.png';
import HeadingSecurityIcon from '../../../assets/HeadingSecurityIcon.png';
import HeadingConvertIcon from '../../../assets/HeadingConvertIcon.png';



export const pdfSecuritySection = {
  icon: HeadingSecurityIcon,
  heading: 'PDF Security',
  description: 'Protect, lock, unlock, and encrypt your PDFs to keep your files private and secure.',
  cards: [
    {
      icon: ToolsPasswordIcon,
      title: 'Set PDF Password',
      description: 'Protect your PDF with a secure password to prevent unauthorized access.',
    },
    {
      icon: ToolsUnlockIcon,
      title: 'Remove PDF Password',
      description: 'Remove passwords from protected PDFs for easier access and sharing.',
    },
    {
      icon: ToolsEncryptIcon,
      title: 'Encrypt any File or Text',
      description: 'Secure your PDF with high-level encryption to keep content confidential.',
    },
    {
      icon: ToolsDecryptIcon,
      title: 'Decrypt any File or Text',
      description: 'Remove encryption from a PDF to make it accessible without a key.',
    },
  ],
};

export const organizePdfSection = {
  icon: HeadingOrganizeIcon,
  heading: 'Organize PDF',
  description: 'Rearrange, split, merge, rotate, or delete pages to customize your PDFs easily.',
  cards: [
    {
      icon: SplitIcon,
      title: 'Split PDF',
      description: 'Break a large PDF into smaller parts or extract specific pages.',
    },
    {
      icon: ReorderIcon,
      title: 'Re-order Pages',
      description: 'Remove passwords from protected PDFs for easier access and sharing.',
    },
    {
      icon: MergeIcon,
      title: 'Merge PDF',
      description: 'Secure your PDF with high-level encryption to keep content confidential.',
    },
    {
      icon: RotateIcon,
      title: 'Rotate PDF',
      description: 'Remove encryption from a PDF to make it accessible without a key.',
    },
    {
      icon: DeleteIcon,
      title: 'Delete PDF',
      description: 'Remove encryption from a PDF to make it accessible without a key.',
    },
  ],
};

export const createPdfSection = {
  icon: HeadingCreateIcon,
  heading: 'Create PDF',
  description: 'Rearrange, split, merge, rotate, or delete pages to customize your PDFs easily.',
  cards: [
    {
      icon: ToolsFormsIcon,
      title: 'Create & Share PDF Forms',
      description: 'Design fillable PDF forms for surveys, registrations, and more.',
    },
    {
      icon: ToolsMcqIcon,
      title: 'Create MCQ Question Paper',
      description: 'Build multiple-choice question papers easily for exams and quizzes.',
    },
    {
      icon: ToolsResumeIcon,
      title: 'Create & Share Resume',
      description: 'Design and export your professional resume in PDF format.',
    }
  ],
};

export const editPdfSection = {
  icon: HeadingEditIcon,
  heading: 'Edit PDF',
  description: 'Rearrange, split, merge, rotate, or delete pages to customize your PDFs easily.',
  cards: [
    {
      icon: ToolsImagePdfIcon,
      title: 'Add Image to PDF',
      description: 'Insert images or logos into your PDF at any position.',
    },
    {
      icon: ToolsTextIcon,
      title: 'Add Text to PDF',
      description: 'Type or paste custom text into any part of your PDF.',
    },
    {
      icon: ToolsHighlightIcon,
      title: 'Highlight in PDF',
      description: 'Mark text by highlighting key points in your document.',
    },
    {
      icon: ToolsWatermarkIcon,
      title: 'Add Watermark to PDF',
      description: 'Protect your content with custom text or image watermarks.',
    },
    {
      icon: EsignYellowIcon,
      title: 'Add eSign to PDF',
      description: 'Easily add your signature to any part of your PDF.',
    },
    {
      icon: EraseYellowIcon,
      title: 'Erase Text from PDF',
      description: 'Remove unwanted text from your PDF quickly and easily.',
    }
  ],
};

export const editImageSection = {
  icon: HeadingEditImageIcon,
  heading: 'Edit Image',
  description: 'Rearrange, split, merge, rotate, or delete pages to customize your PDFs easily.',
  cards: [
    {
      icon: CompressIcon,
      title: 'Compress Image',
      description: 'Reduce image file size without compromising quality.',
    },
    {
      icon: ToolsWebpIcon,
      title: 'WEBP to PNG',
      description: 'Convert WEBP images to the widely used PNG format.',
    },
    {
      icon: ToolsJpgIcon,
      title: 'JPG to PNG',
      description: 'Switch from JPG to PNG format in seconds.',
    },
    {
      icon: ResizeIcon,
      title: 'Resize Image',
      description: 'Adjust image dimensions to fit specific size requirements.',
    }
  ],
};

export const convertToPdfSection = {
  icon: HeadingConvertIcon,
  heading: 'Convert to PDF',
  description: 'Rearrange, split, merge, rotate, or delete pages to customize your PDFs easily.',
  cards: [
    {
      icon: ImageToPdf,
      title: 'Image to PDF',
      description: 'Convert one or more images you like into a single PDF document.',
    },
    {
      icon: PptToPdf,
      title: 'PPT to PDF',
      description: 'Turn your PowerPoint presentations into shareable PDFs.',
    },
    {
      icon: ExcelToPdf,
      title: 'Excel to PDF',
      description: 'Convert Excel spreadsheets into PDF format for better portability.',
    },
    {
      icon: WordToPdf,
      title: 'Word to PDF',
      description: 'Save Word documents as PDFs with perfect formatting.',
    },
    {
      icon: WebpageToPdf,
      title: 'Webpage to PDF',
      description: 'Select webpage and convert it into a downloadable PDF.',
    },
    {
      icon: TextToPdf,
      title: 'Text to PDF',
      description: 'Create a PDF from plain text files or notes.',
    }
  ],
};

export const convertFromPdfSection = {
  icon: HeadingConvertFromPdfIcon,
  heading: 'Convert from PDF',
  description: 'Rearrange, split, merge, rotate, or delete pages to customize your PDFs easily.',
  cards: [
    {
      icon: PdfToImage,
      title: 'PDF to Image',
      description: 'Convert one or more images you like into a single PDF document.',
    },
    {
      icon: PdfToPpt,
      title: 'PDF to PPT',
      description: 'Turn your PowerPoint presentations into shareable PDFs.',
    },
    {
      icon: PdfToExcel,
      title: 'PDF to Excel',
      description: 'Convert Excel spreadsheets into PDF format for better portability.',
    },
    {
      icon: PdfToWord,
      title: 'PDF to Word',
      description: 'Save Word documents as PDFs with perfect formatting.',
    },
    {
      icon: PdfToLong,
      title: 'PDF to Long Image',
      description: 'Select webpage and convert it into a downloadable PDF.',
    }
  ],
};
